import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import React from "react";
import ModalComponent from "../ModalComponent";
import GlobalStyles from "../../globalStyles/globalStyles";
import { Colors } from "../../globalStyles/ColorConfig";
import { updateData } from "../../services/Profile/profileService";
import { PROFILE_ROUTES } from "../../navigation/routes";
import { RootState, useSelector } from "../../redux/store";
import { useNavigation } from "@react-navigation/native";

interface AgeProps {
  isVisible: boolean;
  toggleModal: () => void;
  age: Number;
  dob: any;
}
function month(month: String) {
  if (month == "1") return "January";
  if (month == "2") return "February";
  if (month == "3") return "March";
  if (month == "4") return "April";
  if (month == "5") return "May";
  if (month == "6") return "June";
  if (month == "7") return "July";
  if (month == "8") return "August";
  if (month == "9") return "September";
  if (month == "10") return "October";
  if (month == "11") return "November";
  if (month == "12") return "December";
}

export default function AlertNotEdit({
  isDialog = false,
  isVisible,
  toggleModal,
  reason
  // age,

}: {
  isDialog?: boolean;
  isVisible: any;
  toggleModal: any;
  reason:string
  // age: Number;
  
}) {
  const { userToken } = useSelector((state: RootState) => state.user);
  const navigation = useNavigation();

  const handleConfirm = async () => {
   
   
  };
  return (
    <ModalComponent isVisible={isVisible} toggleModal={toggleModal}>
      <View
        style={{
          justifyContent: "center",
          backgroundColor: "rgba(0, 0, 0, 0.4)", // Background layer color
          width: "100%",
          height: "100%",
          position: "absolute",
          alignItems: "center",
        }}
      >
        <View style={styles.modalWrap}>
          <Text
            style={[GlobalStyles.heading2, { padding: 16, paddingTop: 23 }]}
          >
            You can't modify {`${reason}`}
          </Text>
          <Text
            style={[GlobalStyles.bodyText, { padding: 18, paddingTop: 0 }]}
          >
           {`${reason}`} can't be modify once submitted
          </Text>
          
          <View style={styles.ModalButtonWrap}>
            {/* <TouchableOpacity
              onPress={toggleModal}
              style={[styles.ModalButton, styles.ModalSecondaryButton]}
            >
              <Text
                style={[GlobalStyles.title2, styles.ModalSecondaryButtonText]}
              >
                Edit
              </Text>
            </TouchableOpacity> */}
            <TouchableOpacity
              style={[styles.ModalButton, styles.ModalPrimaryButton]}
              onPress={() => {
                // handleConfirm();
                toggleModal();
              }}
            >
              <Text
                style={[
                  GlobalStyles.title2,
                  styles.ModalButtonText,
                  styles.ModalPrimaryButtonText,
                ]}
              >
                Ok
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </ModalComponent>
  );
}
const styles = StyleSheet.create({
  modalBackground: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.4)", // Background layer color
  },
  ModalPrimaryButton: {
    backgroundColor: Colors.darkGreen,
  },
  ModalSecondaryButton: {},
  ModalSecondaryButtonText: {},
  ModalButtonText: {},
  ModalPrimaryButtonText: {
    color: "#fff",
    fontSize: 16,
  },
  modalWrap: {
    backgroundColor: "white",
    width: "92%",
    overflow: "hidden",
    borderRadius: 8,
  },
  ModalButton: {
    borderWidth: 0.5,
    borderColor: "rgba(0, 0, 0, 0.2)",
    // marginRight: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    paddingVertical: 15,
  },
  ModalButtonWrap: {
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 20,
    width: "100%",
  },
  containerBtnText: {
    fontSize: 16,
    color: "#000",
    textAlign: "center",
  },
  btnPrimary: {
    backgroundColor: "#D9D9D9",
    borderRadius: 4,
  },
  containerBtn: {
    width: "100%",
    paddingVertical: 20,
    marginTop: 40,
    textAlign: "center",
  },

  modalHeader: {
    fontSize: 26,
    fontWeight: "bold",
    textAlign: "left",
  },
  modalContainer: {
    justifyContent: "center",
    width: "100%",
    textAlign: "center",
    position: "absolute",
    top: "35%",
    alignItems: "center",
  },
  modalSubtitle: {
    fontSize: 16,
    marginTop: 6,
    color: "#707070",
  },
});
